<template>
  <div>
    <div class="card card-custom gutter-b example example-compact">
      <div class="card-header">
        <div class="card-title">
          <h3>Händler verwalten</h3>
        </div>
        <div class="card-toolbar" >
          <v-btn
            class="px-7 py-3 font-size-3 text-white invite-btn"
            @click="goToAddNew"
            v-if="is_admin_dealer == 0"
          >
            <b-icon
              icon="plus-circle-fill"
              scale="1"
              aria-hidden="true"
              variant="light"
              class="mr-2"
            ></b-icon>
            Neu hinzufügen
          </v-btn>
          <v-btn
            class="px-7 py-3 font-size-3 text-white invite-btn"
            @click="goToAddNew"
            v-else-if="producers.length == 0 && is_admin_dealer == 1"
          >
            <b-icon
              icon="plus-circle-fill"
              scale="1"
              aria-hidden="true"
              variant="light"
              class="mr-2"
            ></b-icon>
            Neu hinzufügen
          </v-btn>
        </div>
      </div>
      <div class="card-body">
        <div class="text-right" v-if="is_admin_dealer == 0">
          <download-csv
            class="download-csv-btn"
            v-if="allProducers.length"
            :separator-excel="true"
            :data="allProducers"
            name="gustoreich-producer-data.csv"
          >
            <v-btn class="no-button"> Export Händlerdaten </v-btn>
            <!-- <img src="download_icon.png" /> -->
          </download-csv>
        </div>
        <div class="table-responsive mt-5">
          <v-simple-table class="record-table">
            <thead>
              <tr>
                <th width="8%" class="text-center align-middle">
                  Seriennummer
                </th>
                <!-- <th
                  width="25%"
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'first_name',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Händler Name
                  <span class="tbl-sort-icons ml-2">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'first_name'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'first_name' &&
                        filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'first_name' &&
                        filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th> -->
                <th
                  width="25%"
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'company_name',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Firmenname
                  <span class="tbl-sort-icons ml-2" v-if="is_admin_dealer == 0">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'company_name'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'company_name' &&
                        filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'company_name' &&
                        filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th
                  width="25%"
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'email',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  E-Mail
                  <span class="tbl-sort-icons ml-2" v-if="is_admin_dealer == 0">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'email'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'email' && filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'email' && filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th
                  width="25%"
                  class="text-center align-middle"
                  @click="
                    sortListing(
                      'mobile_no',
                      filter.orderBy === 'asc' ? 'desc' : 'asc'
                    )
                  "
                >
                  Telefonnummer
                  <span class="tbl-sort-icons ml-2" v-if="is_admin_dealer == 0">
                    <i
                      class="fa fa-sort"
                      aria-hidden="true"
                      v-if="filter.orderCol !== 'mobile_no'"
                    ></i>
                    <i
                      class="fa fa-sort-up"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'mobile_no' &&
                        filter.orderBy === 'asc'
                      "
                    ></i>
                    <i
                      class="fa fa-sort-down"
                      aria-hidden="true"
                      v-if="
                        filter.orderCol === 'mobile_no' &&
                        filter.orderBy === 'desc'
                      "
                    ></i>
                  </span>
                </th>
                <th class="text-center align-middle" width="17%">Aktionen</th>
              </tr>
            </thead>
            <tr>
              <td></td>
              <td>
                <div class="search-input-div" v-if="is_admin_dealer == 0">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchNameKey"
                    solo
                    label="Firmenname suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div" v-if="is_admin_dealer == 0">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchEmailKey"
                    solo
                    label="E-Mail suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="search-input-div" v-if="is_admin_dealer == 0">
                  <v-text-field
                    dense
                    autocomplete="new-password"
                    v-model.lazy="searchPhoneKey"
                    solo
                    label="Telefonnummer suchen..."
                    clearable
                  ></v-text-field>
                </div>
              </td>
              <td></td>
            </tr>
            <tbody v-if="producers.length">
              <tr v-for="(producer, i) in producers" :key="producer.id">
                <td
                  class="align-middle clickable-td"
                  :class="is_admin_dealer ? 'text-center' :''"
                  @click="
                    NavigateToEdit(
                      producer.id,
                      producer.country,
                      producer.mobile_no
                    )
                  "
                >
                  {{ i + 1 }}
                </td>
                <!-- <td
                  class="align-middle clickable-td"
                  @click="
                    NavigateToEdit(
                      producer.id,
                      producer.country,
                      producer.mobile_no
                    )
                  "
                >
                  {{ producer.first_name + " " + producer.last_name }}
                </td> -->
                <td
                  v-if="producer.company_name"
                  class="align-middle clickable-td"
                  :class="is_admin_dealer ? 'text-center' :''"
                  @click="
                    NavigateToEdit(
                      producer.id,
                      producer.country,
                      producer.mobile_no
                    )
                  "
                >
                  {{
                    producer.company_name.length > 50
                      ? producer.company_name.substr(0, 50) + "..."
                      : producer.company_name
                  }}
                </td>
                <td
                  v-else
                  class="align-middle text-center clickable-td"
                  :class="is_admin_dealer ? 'text-center' :''"
                  @click="
                    NavigateToEdit(
                      producer.id,
                      producer.country,
                      producer.mobile_no
                    )
                  "
                >
                  -
                </td>
                <td
                  class="align-middle clickable-td"
                  :class="is_admin_dealer ? 'text-center' :''"
                  @click="
                    NavigateToEdit(
                      producer.id,
                      producer.country,
                      producer.mobile_no
                    )
                  "
                >
                  {{ producer.email }}
                </td>
                <td
                  class="align-middle clickable-td"
                  :class="is_admin_dealer ? 'text-center' :''"
                  @click="
                    NavigateToEdit(
                      producer.id,
                      producer.country,
                      producer.mobile_no
                    )
                  "
                >
                  {{ producer.mobile_no }}
                </td>
                <td class="align-middle text-center icon-wrapper-block">
                  <router-link
                    :to="
                      '/admin/manage/producer-details/' +
                      producer.brand_name_slug"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="search"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Details anzeigen</span>
                    </v-tooltip>
                  </router-link>
                  <router-link v-if="is_admin_dealer == 0" :to="'/admin/producer-products/' + producer.id">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="minecart"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Produkte anzeigen</span>
                    </v-tooltip>
                  </router-link>
                  <a
                    @click="
                      NavigateToEdit(
                        producer.id,
                        producer.country,
                        producer.mobile_no
                      )
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <i v-bind="attrs" v-on="on" class="flaticon-edit-1"></i>
                      </template>
                      <span>Bearbeiten</span>
                    </v-tooltip>
                  </a>

                  <a
                    @click="NavigateToEditGeneralSetting(producer.id)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <i v-bind="attrs" v-on="on" class="flaticon-cogwheel-2"></i>
                      </template>
                      <span>Allgemeine Einstellung bearbeiten</span>
                    </v-tooltip>
                  </a>

                  <a
                    v-if="
                      producer.terms_condition && producer.terms_condition != ''
                    "
                    :href="producer.terms_condition"
                    target="_blank"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="file-earmark"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>AGB</span>
                    </v-tooltip>
                  </a>

                  <a
                    v-if="producer.is_status == 1"
                    @click="changeStatus(producer.id, producer.is_status)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Aktiviert</span>
                    </v-tooltip>
                  </a>
                  <a
                    v-else
                    @click="changeStatus(producer.id, producer.is_status)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="eye-slash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Deaktiviert</span>
                    </v-tooltip>
                    <!-- <v-icon small>fas fa-eye-slash</v-icon> -->
                  </a>
                  <a @click="deleteProducer(producer.id)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <b-icon
                          v-bind="attrs"
                          v-on="on"
                          icon="trash"
                          scale="1.3"
                          aria-hidden="true"
                        ></b-icon>
                      </template>
                      <span>Löschen</span>
                    </v-tooltip>
                  </a>
                </td>
              </tr>
            </tbody>
            <tbody
              v-else-if="loading_producers"
              class="loading-tbody text-center"
            >
              <td class="text-center" colspan="5">
                Wird geladen...
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
              </td>
            </tbody>
            <tbody v-else class="loading-tbody text-center">
              <tr>
                <td class="text-center" colspan="5">Keine Einträge gefunden</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex pagination-block" v-if="is_admin_dealer == 0">
            <b-pagination
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total-rows="pagination.paginationRows"
              prev-text="Voriges"
              next-text="Nächstes"
              first-number
              last-number
              @change="paginationChange"
            >
              <template #prev-text
                ><span
                  ><b-icon
                    icon="chevron-left"
                    aria-hidden="true"
                    rel="prev"
                  ></b-icon></span
              ></template>
              <template #next-text
                ><span
                  ><b-icon
                    icon="chevron-right"
                    aria-hidden="true"
                    rel="next"
                  ></b-icon></span
              ></template>
            </b-pagination>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="statusDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Status wirklich ändern?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="changeStatusRecord(statusRecordId, newStatus)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div></div>
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Bitte bestätigen
        </v-card-title>

        <v-card-text>
          <span>Wollen Sie den Eintrag wirklich löschen?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="disabledCancel"
            class="no-button"
            @click="hideModal"
          >
            Nein
          </v-btn>
          <v-btn
            type="submit"
            @click="deleteRecord(deleteRecordId)"
            ref="kt_form_submit_btn"
            class="yes-button"
            :loading="yesActionLoading"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="producers" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
//import axios from "axios";
import HtmlClass from "@/core/services/htmlclass.service";
//import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Notifications from "vue-notification";
//import Loader from "@/components/admin/layout/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";
import JsonCSV from "vue-json-csv";

Vue.component("downloadCsv", JsonCSV);

Vue.use(Notifications);

export default {
  name: "Producers",
  props: {
    data: {
      type: String,
      required: true
    }
  },
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("local_products_user_access_id");
      this.getProducers();
      this.getProducerStatus();
    }
   
  },
  data() {
    return {
      is_admin_dealer:this.data ? this.data: 0,
      loading_producers: true,
      filter: {
        orderCol: "id",
        orderBy: "desc",
      },
      searchNameKey: "",
      searchEmailKey: "",
      searchPhoneKey: "",
      yesActionLoading: false,
      disabledCancel: false,
      userId: null,
      //providers: [],
      producers: [],
      allProducers: [],
      statusDialog: false,
      deleteDialog: false,
      deleteRecordId: null,
      statusRecordId: null,
      newStatus: null,
      pagination: {
        currentPage: 1,
        perPage: 20,
        paginationRows: "",
      },
    };
  },
  components: {},
  watch: {
    searchNameKey: {
      handler: function (val, oldVal) {
        this.producers = [];
        this.loading_producers = true;
        this.getProducers();
      },
      deep: true,
    },
    searchEmailKey: {
      handler: function (val, oldVal) {
        this.producers = [];
        this.loading_producers = true;
        this.getProducers();
      },
      deep: true,
    },
    searchPhoneKey: {
      handler: function (val, oldVal) {
        this.producers = [];
        this.loading_producers = true;
        this.getProducers();
      },
      deep: true,
    },
  },
  methods: {
    decodeID(id) {
      return btoa(id);
    },
    hideModal() {
      this.statusDialog = false;
      this.yesActionLoading = false;
      this.deleteDialog = false;
    },
    goToAddNew() {
      if (this.is_admin_dealer) {
        this.$router.push({ name: "manage-add-producer" });
      }else{
        this.$router.push({ name: "add-producer" });
      }
      
    },
    NavigateToEdit(id, country, phone) {
      localStorage.setItem("currentProviderCountry", country);
      localStorage.setItem("currentProviderPhone", phone);
      if (this.is_admin_dealer) {
        this.$router.push({ path: `/admin/manage/edit-producer/${id}` }); 
      } else {
        this.$router.push({ path: `/admin/edit-producer/${id}` });
      }
     
    },
    NavigateToEditGeneralSetting(id) {
      if (this.is_admin_dealer) {
        this.$router.push({ path: `/admin/manage/edit-general-setting/${id}` });
      } else {
        this.$router.push({ path: `/admin/edit-general-setting/${id}` });
      }
     
    },
    sortListing(orderCol, orderBy) {
      if (!this.loading_producers) {
        this.producers = [];
        this.filter.orderCol = orderCol;
        this.filter.orderBy = orderBy;
        this.pagination.currentPage = 1;
        this.loading_producers = true;
        this.getProducers();
      }
    },
    paginationChange() {
      this.producers = [];
      this.loading_producers = true;
      setTimeout(() => {
        this.getProducers();
      }, 100);
    },
    getProducerStatus() {
      let data = {
        user_id: this.currentUser.id,
      };
      adminAPI.getProducerStatus(data).then((response) => {
        if (response.status == "success") {
          this.allProducers = response.data;
        }
      });
    },
    getProducers() {
      let data = {
        user_id: this.currentUser.id,
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
        search_company_field: this.searchNameKey,
        search_email_field: this.searchEmailKey,
        search_phone_field: this.searchPhoneKey,
        sort_column: this.filter.orderCol,
        sort_type: this.filter.orderBy,
        is_admin_dealer:this.is_admin_dealer
      };
      adminAPI
        .getProducers(data)
        .then((response) => {
          if (response.status == "success") {
            this.producers = response.data;
            this.pagination.paginationRows = response.count;
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_producers = false;
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.loading_producers = false;
            this.$notify({
              group: "producers",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.loading_producers = false;
          this.$notify({
            group: "producers",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    deleteProducer(id) {
      this.deleteDialog = true;
      this.deleteRecordId = id;
    },
    deleteRecord(id) {
      this.disabledCancel = true;
      this.yesActionLoading = true;
      adminAPI
        //.deleteProducer([{ producer_id: id }])
        .deleteProducer({ producer_id: [id] })
        .then((response) => {
          if (response.status == "success") {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "producers",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.pagination.currentPage = 1;
            this.getProducers();
          } else {
            this.deleteDialog = false;
            this.deleteRecordId = null;
            this.disabledCancel = false;
            this.yesActionLoading = false;
            this.$notify({
              group: "producers",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.deleteDialog = false;
          this.deleteRecordId = null;
          this.disabledCancel = false;
          this.yesActionLoading = false;
          this.$notify({
            group: "producers",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    changeStatus(id, status) {
      if (status == 0) {
        this.newStatus = "1";
      } else {
        this.newStatus = "0";
      }
      this.statusDialog = true;
      this.statusRecordId = id;
    },
    changeStatusRecord(id, status) {
      this.yesActionLoading = true;
      this.disabledCancel = true;
      adminAPI
        .statusProducer({ id: id, status: status })
        .then((response) => {
          if (response.status == "success") {
            this.$notify({
              group: "producers",
              type: "success",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.getProducers();
          } else {
            this.statusDialog = false;
            this.statusRecordId = null;
            this.newStatus = null;
            this.yesActionLoading = false;
            this.disabledCancel = false;
            this.$notify({
              group: "producers",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.statusDialog = false;
          this.statusRecordId = null;
          this.newStatus = null;
          this.yesActionLoading = false;
          this.disabledCancel = false;
          this.$notify({
            group: "producers",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

<style scoped>
a {
  cursor: pointer;
}

th {
  cursor: pointer;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  height: 48px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 14px;
  height: 48px;
}

.clickable-td {
  cursor: pointer;
}
</style>

